import { css } from '@emotion/react';
import { TextSubtitle1RMMixin } from '@mobalytics/shared';

export const paymentFormHeaderCss = css`
  ${TextSubtitle1RMMixin};
  margin-bottom: 24px;
`;
